export enum BookingSourceDTO {
    Customer = 'CUSTOMER',
    Google = 'GOOGLE',
    Merchant = 'MERCHANT',
}
